import gql from 'graphql-tag.macro';
import { mergeResolvers } from '@graphql-tools/merge';

export const typeDefs = gql`
  type MyType {
    id: ID!
    name: String!
  }
`;

export const resolvers = mergeResolvers([]);
